import { render } from "./all-locks-grid.vue?vue&type=template&id=f08a36b6"
import script from "./all-locks-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./all-locks-grid.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/locks/all-locks-grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f08a36b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f08a36b6', __exports__)) {
    api.reload('f08a36b6', __exports__)
  }
  
  module.hot.accept("./all-locks-grid.vue?vue&type=template&id=f08a36b6", () => {
    api.rerender('f08a36b6', render)
  })

}


export default __exports__